import { useState, useEffect } from 'react';
import { listenToCollection } from '../services/firestore.service';
import { where, orderBy } from 'firebase/firestore';

export const useMarketListings = (assetType) => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const constraints = [where('status', '==', 'active')];
    if (assetType) {
      constraints.push(where('assetType', '==', assetType));
    }
    // Ordering requires an index, so we might need to be careful or rely on default ordering
    // constraints.push(orderBy('createdAt', 'desc')); 

    setLoading(true);
    const unsubscribe = listenToCollection(
      'market',
      constraints,
      (data) => {
        setListings(data);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [assetType]);

  return { listings, loading, error };
};

